export default {"src":"/_next/static/media/techLogo2.bc8025d4.svg","height":48,"width":98,"blurWidth":0,"blurHeight":0};